import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ComponentsModule } from 'src/app/components/components.module';
import { PlayerDashboardComponent } from './player-dashboard.component';
import { PlayerDashboardService } from 'src/app/services/player-dashboard/player-dashboard.service';
import { BonusSectionComponent } from './bonus-section/bonus-section.component';
import { ReactiveFormsModule } from '@angular/forms';
import { PromotionsSectionComponent } from './promotions-section/promotions-section.component';
import { SwiperModule } from 'swiper/angular';
import { GamesSectionComponent } from './games-section/games-section.component';
import { PlurarTextPipe } from 'src/app/pipes/plurar.pipe';
import { PlayerDashboardPromotionActionButtonsComponent } from './promotion-action-buttons/promotion-action-buttons.component';


@NgModule({
  declarations: [
    PlayerDashboardComponent,
    BonusSectionComponent,
    PromotionsSectionComponent,
    GamesSectionComponent,
    PlayerDashboardPromotionActionButtonsComponent,
  ],
  imports: [
    CommonModule,
    IonicModule,
    ComponentsModule,
    ReactiveFormsModule,
    SwiperModule,
    PlurarTextPipe
  ],
  providers: [PlayerDashboardService]
})
export class PlayerDashboardModule {}